import axios from "axios";
import { request } from "@/utils/request";
export default {
  data: function data() {
    return {
      url: process.env.VUE_APP_API_APP_CATEGORY_PREVIERW
    };
  }
};